
function checkTabOverflowing(tabEl)
{
	const contentEl = tabEl.querySelector('.content');
	if (!contentEl)
		return;

	if (contentEl.scrollHeight > contentEl.clientHeight)
		tabEl.classList.add('overflowing');
	else
		tabEl.classList.remove('overflowing');
}


export default function initProductScript()
{
	let isAnimating = false; // Flaga, aby śledzić, czy slick jest w trakcie animacji

	jQuery(".single-product-slick-wrapper").on('beforeChange', () => isAnimating = true);
	jQuery(".single-product-slick-wrapper").on('afterChange', () => isAnimating = false);

	const tabButtons = {};
	const tabContents = {};
	const slickTabs = {};

	for (const tab of document.querySelectorAll('.prod-tabs [data-tab]'))
		tabButtons[ tab.getAttribute('data-tab') ] = tab;

	for (const tab of document.querySelectorAll('.prod-tab-contents [data-tab]'))
		tabContents[ tab.getAttribute('data-tab') ] = tab;

	for (const tab of document.querySelectorAll('.single-product-slick-wrapper [data-tab]'))
	{
		for (const tabId of tab.getAttribute('data-tab').split(' '))
		{
			if (!tabId.trim())
				continue;

			if (!slickTabs[ tabId ])
				slickTabs[ tabId ] = [];

			slickTabs[ tabId ].push(tab);
		}
	}

	function getSlideIndex(tabId)
	{
		if (!slickTabs[ tabId ])
			return -1;

		return [ ...document.querySelector(".slick-track").childNodes ].indexOf(slickTabs[ tabId ][ 0 ]);
	}

	let nextSlideId = null;

	function setTab(tabId, updateSlider = true)
	{
		for (const otherTabButton of Object.values(tabButtons))
			otherTabButton.classList.remove('active');

		for (const otherTabContent of Object.values(tabContents))
			otherTabContent.classList.remove('active');

		tabButtons[ tabId ]?.classList.add('active');
		tabContents[ tabId ]?.classList.add('active');

		checkTabOverflowing(tabContents[ tabId ]);

		if (!updateSlider)
			return;

		nextSlideId = tabId;
		const slideIndex = getSlideIndex(tabId);

		if (slideIndex >= 0)
			jQuery('.single-product-slick-wrapper').slick('slickGoTo', slideIndex);
	}

	for (const tabId in tabButtons)
	{
		tabButtons[ tabId ].addEventListener('click', () =>
		{
			if (isAnimating)
				return;

			setTab(tabId);
		});
	}

	jQuery(".single-product-slick-wrapper").on("beforeChange", function(event, slick, currentSlide, nextSlide)
	{
		const tabIds = slick.$slides.get(nextSlide).dataset?.tab?.split(' ');

		if (!tabIds || tabIds.includes(nextSlideId))
			return;

		const tabId = tabIds[ 0 ];

		if (tabId !== undefined)
			setTab(tabId);
	});

	for (const tabContent of Object.values(tabContents))
	{
		checkTabOverflowing(tabContent);
	}

	window.addEventListener('resize', () =>
	{
		for (const tabContent of Object.values(tabContents))
		{
			checkTabOverflowing(tabContent);
		}
	});

	for (const btn of document.querySelectorAll('.prod-tab-contents .tab button.expand'))
	{
		btn.addEventListener('click', () =>
		{
			const tab = btn.closest('.tab');
			if (tab.classList.contains('expanded'))
			{
				tab.classList.remove('expanded');
				if (document.documentElement.lang == 'pl-PL')
					btn.textContent = 'Rozwiń';
				else
					btn.textContent = 'Expand';
			}
			else
			{
				tab.classList.add('expanded');
				if (document.documentElement.lang == 'pl-PL')
					btn.textContent = 'Zwiń';
				else
					btn.textContent = 'Collapse';
			}
		});
	}
}
